import authInterceptor from "../AuthInterceptor";

export const NotificationsAPI = {
  list: (
    { page = 1, page_size = 50, unread_only = false, event_type, search } = {},
    config = {}
  ) =>
    authInterceptor
      .get(`notifications-api/list`, {
        ...config,
        params: {
          page,
          page_size,
          unread_only,
          ...(event_type ? { event_type } : {}),
          ...(search ? { search } : {}),
          ...(config?.params || {}),
        },
      })
      .then((response) => response.data)
      .catch((error) => error.response),

  unreadCount: (config = {}) =>
    authInterceptor
      .get(`notifications-api/unread-count`, config)
      .then((response) => response.data)
      .catch((error) => error.response),

  markRead: (bodyData) =>
    authInterceptor
      .post(`notifications-api/mark-read`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),

  markUnread: (bodyData) =>
    authInterceptor
      .post(`notifications-api/mark-unread`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),

  dismiss: (bodyData) =>
    authInterceptor
      .post(`notifications-api/dismiss`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
};
